import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 13" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width={1.5}
      d="M1 7.382h3.6v-1.86a1.08 1.08 0 0 1 2.16 0v5.416a1.091 1.091 0 0 0 2.183 0v-8.37a1.069 1.069 0 0 1 2.137 0V9.42a1.08 1.08 0 1 0 2.16 0V5.521a1.08 1.08 0 0 1 2.16 0v1.861H19"
    />
  </svg>
);
export const BlindReaderIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
